import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { CreateChancel, Input } from 'components';
import { goalActions } from 'store';
import { httpRequestsOnErrorsActions, httpRequestsOnSuccessActions } from 'store';
import { FindLoad, FindSuccessItem, useModal } from 'utils';

export const AddGoalSection = ({ info, afterSuccess }) => {
    const ACTION_TYPE = info ? 'EDIT_SECTION_TYPE' : 'CREATE_SECTION_TYPE';
    const dispatch = useDispatch();
    const success = FindSuccessItem(ACTION_TYPE);
    const loader = FindLoad(ACTION_TYPE);
    const { close } = useModal();
    const {
        handleSubmit,
        control,
        clearErrors,
        reset,
        formState: { errors },
    } = useForm();

    useEffect(() => {
        if (info) {
            const result = {
                ...info,
            };
            reset(result);
        }
    }, [info]);

    useEffect(() => {
        return () => {
            clearErrors();
            dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE));
        };
    }, []);

    useEffect(() => {
        if (success) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
            close();
            if (afterSuccess) {
                afterSuccess();
            }
        }
    }, [success]);

    const handleCreate = (data) => {
        const body = { name: data.name };
        if (info) {
            dispatch(goalActions.editSectionType(info.id, body));
        } else {
            dispatch(goalActions.createSectionType(body));
        }
    };

    return (
        <div style={{ width: 400 }}>
            <p className="modal-header-title">{info ? 'Edit Goal Section' : 'Add Goal Section'}</p>
            <form onSubmit={handleSubmit(handleCreate)}>
                <div className="modal-body-wrapper">
                    <div className="full-width">
                        <Input
                            name="name"
                            label="Section Name*"
                            variant="outlined"
                            control={control}
                            maxLength={50}
                            rules={{
                                maxLength: {
                                    value: 50,
                                    message: 'Max length is 50 digits.',
                                },
                                required: 'Section name is required.',
                            }}
                        />
                    </div>
                </div>
                <CreateChancel
                    type="submit"
                    loader={!!loader.length}
                    create={info ? 'Save Changes' : 'Add'}
                    chancel={'Cancel'}
                    onClose={close}
                    buttonWidth="100%"
                    cancelRight={'24px'}
                />
            </form>
        </div>
    );
};
